"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.labelsStore = void 0;
const api_1 = require("client/api");
const ui_1 = require("client/components/ui");
const print_labels_1 = require("client/modules/labels/print-labels");
const mobx_1 = require("mobx");
class LabelsStore {
    constructor() {
        this.prescribedClaims = {
            error: "",
            loading: false,
            status: ui_1.FormStatus.Clean,
            value: []
        };
        this.claimNdcMonographs = [];
        this.attemptPassToServer = async (pdf, claim, siteId) => {
            await api_1.OrderEndpoint.savePDF.apiCall(null, {
                claim,
                pdf,
                siteId
            });
        };
        this.listClaimNdcMonographs = async (claims) => {
            const result = await api_1.PrescribeEndpoint.listclaimndcmonographs.apiCall(null, {
                claims
            });
            if (api_1.isError(result)) {
                console.error("Error in LabelsManager.print() ", result);
                this.claimNdcMonographs = [];
            }
            else {
                this.claimNdcMonographs = result.claimNdcMonographs;
            }
        };
        /** Query Actions */
        this.listPrescribedClaims = async (query) => {
            this.prescribedClaims.loading = true;
            const result = await api_1.PrescribeEndpoint.listprescribedclaims.apiCall({
                query
            });
            if (api_1.isError(result)) {
                console.error("Error in listPrescribedClaims query", result);
                this.prescribedClaims = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.prescribedClaims.value
                };
            }
            else {
                this.prescribedClaims = {
                    loading: false,
                    status: ui_1.FormStatus.Saved,
                    value: result.claims
                };
                /** Should probably be added to an observable but I'm over this BS. */
                return result.orders;
            }
        };
        this.updateClaimLots = async (claimMetas, action) => {
            const result = await api_1.PrescribeEndpoint.updateclaimlots.apiCall(null, {
                action,
                claimMetas
            });
            if (api_1.isError(result)) {
                console.error("Error in updateClaimLots", result);
            }
            else {
                console.info("result is", result);
            }
        };
        this.clearClaimLots = async (claim) => {
            const result = await api_1.PrescribeEndpoint.clearclaimlots.apiCall(null, {
                claim
            });
            if (api_1.isError(result)) {
                console.error("Error in clearClaimLots", result);
            }
            else {
                console.info("result is", result);
            }
        };
        this.printLabels = async (claims, type) => {
            print_labels_1.labelsManager.print(claims, type);
        };
    }
}
__decorate([
    mobx_1.observable
], LabelsStore.prototype, "prescribedClaims", void 0);
__decorate([
    mobx_1.observable
], LabelsStore.prototype, "claimNdcMonographs", void 0);
__decorate([
    mobx_1.action
], LabelsStore.prototype, "attemptPassToServer", void 0);
__decorate([
    mobx_1.action
], LabelsStore.prototype, "listClaimNdcMonographs", void 0);
__decorate([
    mobx_1.action
], LabelsStore.prototype, "listPrescribedClaims", void 0);
__decorate([
    mobx_1.action
], LabelsStore.prototype, "updateClaimLots", void 0);
__decorate([
    mobx_1.action
], LabelsStore.prototype, "clearClaimLots", void 0);
__decorate([
    mobx_1.action
], LabelsStore.prototype, "printLabels", void 0);
exports.labelsStore = new LabelsStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/labels/store.ts
// module id = 2440
// module chunks = 0 1